/* global mixpanel */
import moment from 'moment'
import formatDate from 'mixpanel/formatDate'

/**
 * @param profile data from api profile
 */
export function identifyFromProfile ({profile}) {
  mixpanel.identify(profile.id)
  mixpanel.people.set({
    $email: profile.email,
    $first_name: profile.first_name,
    $last_name: profile.last_name,
    $created: formatDate(profile.created_at),
    'Last Login': formatDate(moment()),
    'Phone': profile.phone,
    'Business Name': profile.business.name,
    'Business Type ID': profile.business.business_type_id,
    'Business Category ID': profile.business.business_category_id,
    'Business Address': profile.business.address,
    'Business City': profile.business.city,
    'Business State': profile.business.province,
    'Business ZIP': profile.business.zip
  })
}

export function login ({profile}) {
  mixpanel.track('Login', {
    'Active Subscription': profile.already_subscribed,
    'Is Business Owner': profile.is_owner,
    'Email': profile.email
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/login/index.js